var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop",
              attrs: {
                title: _vm.$t("importBillUpload.bankSlipUploadApplyInvoice"),
                isShowFollow: false,
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      "label-position": "top",
                      rules: _vm.rules,
                      model: _vm.form,
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required reqired",
                                attrs: {
                                  prop: "paymentNo",
                                  label:
                                    _vm.$t("importBillUpload.paymentNo") + ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.form.paymentNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "paymentNo", $$v)
                                    },
                                    expression: "form.paymentNo",
                                  },
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "p-color" }, [
                                  _vm._v(
                                    "付款抬头必须与开票抬头一致，否则作废发票重开需要收取费用。"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required reqired",
                                attrs: {
                                  prop: "paymentWay",
                                  label:
                                    _vm.$t("importBillUpload.paymentWay") + ":",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.form.paymentWay,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentWay", $$v)
                                      },
                                      expression: "form.paymentWay",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "01" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "importBillUpload.paymentInCny"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    this.pod != "CNNSA" && this.pod != "CNYPG"
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: "02" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "importBillUpload.paymentInUsd"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    this.pod != "CNNSA" && this.pod != "CNYPG"
                                      ? _c(
                                          "el-radio",
                                          { attrs: { label: "03" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "importBillUpload.paymentInHkd"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "00" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "importBillUpload.originalCurrencyPay"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "p-color" }, [
                                  _vm._v(
                                    "如需非以上方式的其他方式付款，请邮件联系船公司特殊处理。"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "invoiceWay",
                                  label:
                                    _vm.$t("importBillUpload.invoiceWay") + ":",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "no-arrow",
                                    attrs: { disabled: true },
                                    model: {
                                      value: _vm.form.invoiceWay,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "invoiceWay", $$v)
                                      },
                                      expression: "form.invoiceWay",
                                    },
                                  },
                                  _vm._l(_vm.invoiceWayList, function (item) {
                                    return _c("el-option", {
                                      key: item.codeValue,
                                      attrs: {
                                        label:
                                          _vm.language === "zh"
                                            ? item.displayValueCn
                                            : item.displayValue,
                                        value: item.codeValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "p-color" }, [
                                  _vm._v(
                                    "我司只能开具电子发票，如接收电子发票邮箱有更新，请联系邮箱DOC_GZ@SITC.COM"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.pod != "CNNSA" && _vm.pod != "CNYPG"
                              ? _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "b-color",
                                    staticStyle: { "margin-top": "30px" },
                                    on: { change: _vm.handleCheckboxChange },
                                    model: {
                                      value: _vm.form.bankSlipDOF,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "bankSlipDOF", $$v)
                                      },
                                      expression: "form.bankSlipDOF",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("importBillUpload.bankSlipDOF")
                                      ) + "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _vm.pod != "CNSHK"
                              ? _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "b-color",
                                    staticStyle: { "margin-top": "30px" },
                                    model: {
                                      value: _vm.form.extract,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "extract", $$v)
                                      },
                                      expression: "form.extract",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("importBillUpload.extract")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.paymentWay === "01"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "amountAllRMB",
                                          label: "RMB:",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.form.amountAllRMB,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountAllRMB",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountAllRMB",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "26px" },
                                        attrs: { prop: "amountAllRMBFileId" },
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              multiple: "",
                                              limit: 1,
                                              "http-request":
                                                _vm.uploadAmountAllRMBFile,
                                              "on-remove":
                                                _vm.handleAmountAllRMBFile,
                                              "before-remove": _vm.beforeRemove,
                                              accept: _vm.acceptList,
                                              "file-list":
                                                _vm.amountAllRMBFileList,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload2",
                                                  size: "small",
                                                  type: "primary",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "blExchangeAppointment.selectFile"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.paymentWay === "02"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "amountAllUSD",
                                          label: "USD:",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.form.amountAllUSD,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountAllUSD",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountAllUSD",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "26px" },
                                        attrs: { prop: "amountAllUSDFileId" },
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              multiple: "",
                                              limit: 1,
                                              "http-request":
                                                _vm.uploadAmountAllUSDFile,
                                              "on-remove":
                                                _vm.handleAmountAllUSDFile,
                                              "before-remove": _vm.beforeRemove,
                                              accept: _vm.acceptList,
                                              "file-list":
                                                _vm.amountAllUSDFileList,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload2",
                                                  size: "small",
                                                  type: "primary",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "blExchangeAppointment.selectFile"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.paymentWay === "03"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "amountAllHKD",
                                          label: "HKD:",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.form.amountAllHKD,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountAllHKD",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountAllHKD",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "26px" },
                                        attrs: { prop: "amountAllHKDFileId" },
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              multiple: "",
                                              limit: 1,
                                              "http-request":
                                                _vm.uploadAmountAllHKDFile,
                                              "on-remove":
                                                _vm.handleAmountAllHKDFile,
                                              "before-remove": _vm.beforeRemove,
                                              accept: _vm.acceptList,
                                              "file-list":
                                                _vm.amountAllHKDFileList,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload2",
                                                  size: "small",
                                                  type: "primary",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "blExchangeAppointment.selectFile"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.paymentWay === "00"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "amountRMB",
                                          label: "RMB:",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.form.amountRMB,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountRMB",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountRMB",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "26px" },
                                        attrs: { prop: "amountRMBFileId" },
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              multiple: "",
                                              limit: 1,
                                              "http-request":
                                                _vm.uploadAmountRMBFile,
                                              "on-remove":
                                                _vm.handleAmountRMBFile,
                                              "before-remove": _vm.beforeRemove,
                                              accept: _vm.acceptList,
                                              "file-list":
                                                _vm.amountRMBFileList,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload2",
                                                  size: "small",
                                                  type: "primary",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "blExchangeAppointment.selectFile"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "amountUSD",
                                          label: "USD:",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.form.amountUSD,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountUSD",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountUSD",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "26px" },
                                        attrs: { prop: "amountUSDFileId" },
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              multiple: "",
                                              limit: 1,
                                              "http-request":
                                                _vm.uploadAmountUSDFile,
                                              "on-remove":
                                                _vm.handleAmountUSDFile,
                                              "before-remove": _vm.beforeRemove,
                                              accept: _vm.acceptList,
                                              "file-list":
                                                _vm.amountUSDFileList,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload2",
                                                  size: "small",
                                                  type: "primary",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "blExchangeAppointment.selectFile"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop: "amountHKD",
                                          label: "HKD:",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.form.amountHKD,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "amountHKD",
                                                $$v
                                              )
                                            },
                                            expression: "form.amountHKD",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-top": "26px" },
                                        attrs: { prop: "amountHKDFileId" },
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            ref: "upload",
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: "",
                                              multiple: "",
                                              limit: 1,
                                              "http-request":
                                                _vm.uploadAmountHKDFile,
                                              "on-remove":
                                                _vm.handleAmountHKDFile,
                                              "before-remove": _vm.beforeRemove,
                                              accept: _vm.acceptList,
                                              "file-list":
                                                _vm.amountHKDFileList,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload2",
                                                  size: "small",
                                                  type: "primary",
                                                  plain: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "blExchangeAppointment.selectFile"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("importBillUpload.extractAmount")
                                    ) +
                                    "\n                "
                                ),
                                _c("el-input", {
                                  attrs: { disabled: !_vm.form.extract },
                                  model: {
                                    value: _vm.form.extractAmount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "extractAmount", $$v)
                                    },
                                    expression: "form.extractAmount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "receiveEmail",
                                  label:
                                    _vm.$t("importBillUpload.receiveEmail") +
                                    ":",
                                },
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "light",
                                      content: _vm.form.receiveEmail,
                                      placement: "right",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "max-width": "500px" },
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [_vm._v(_vm._s(_vm.form.receiveEmail))]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                        { name: "trim", rawName: "v-trim" },
                                        { name: "fth", rawName: "v-fth" },
                                      ],
                                      attrs: { maxlength: "300" },
                                      model: {
                                        value: _vm.form.receiveEmail,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "receiveEmail",
                                            $$v
                                          )
                                        },
                                        expression: "form.receiveEmail",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "address",
                                  label:
                                    _vm.$t("importBillUpload.address") + ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: "60" },
                                  model: {
                                    value: _vm.form.address,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "phone",
                                  label: _vm.$t("importBillUpload.phone") + ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { maxlength: "20" },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "accountBank",
                                  label:
                                    _vm.$t("importBillUpload.accountBank") +
                                    ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: "60" },
                                  model: {
                                    value: _vm.form.accountBank,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountBank", $$v)
                                    },
                                    expression: "form.accountBank",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "account",
                                  label:
                                    _vm.$t("importBillUpload.account") + ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: "60" },
                                  model: {
                                    value: _vm.form.account,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "account", $$v)
                                    },
                                    expression: "form.account",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "bankUsd",
                                  label:
                                    _vm.$t("importBillUpload.bankUsd") + ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: "60" },
                                  model: {
                                    value: _vm.form.bankUsd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "bankUsd", $$v)
                                    },
                                    expression: "form.bankUsd",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "accountUsd",
                                  label:
                                    _vm.$t("importBillUpload.accountUsd") + ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: "60" },
                                  model: {
                                    value: _vm.form.accountUsd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountUsd", $$v)
                                    },
                                    expression: "form.accountUsd",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "invoiceTaxNo",
                                  label:
                                    _vm.$t("importBillUpload.invoiceTaxNo") +
                                    ":",
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: { maxlength: "60" },
                                  model: {
                                    value: _vm.form.invoiceTaxNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceTaxNo", $$v)
                                    },
                                    expression: "form.invoiceTaxNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "remark",
                                  label: _vm.$t("importBillUpload.remark"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    type: "textarea",
                                    maxLength: "500",
                                    autosize: { minRows: 2, maxRows: 4 },
                                  },
                                  model: {
                                    value: _vm.form.remark,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "remark", $$v)
                                    },
                                    expression: "form.remark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-color" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-link",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "red",
                              },
                              attrs: { icon: "el-icon-warning-outline" },
                            },
                            [_vm._v("水单上传说明:")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("1)请上传正确水单文件，否则无法成功预约"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n              2)为提高换单效率，银行水单上传格式将限制为PDF/JPG/PNG/BMP/TIFF，除上述文件格式以外内容将限制上传。一次预约多次付款需上传多份文件的客户，烦请合成一份PDF文件，谢谢!"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "3)如果是第一次申请开票或公司信息更新的需要填写发票相关信息!"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-button" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleSave },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.save")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("bankSlipConfirmDialog", {
        ref: "bankSlipConfirmDialog",
        attrs: {
          "destroy-on-close": true,
          width: "50%",
          formDialogConFirm: _vm.form,
          visible: _vm.bankSlipConfirmDialogVisible,
        },
        on: {
          handleBankSlipConfirmSave: _vm.handleBankSlipConfirmSave,
          "update:visible": function ($event) {
            _vm.bankSlipConfirmDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }